export default __webpack_public_path__ + "static/media/SONORA 46 - ANEXO_1_PREMIOS_IMPULSO_SUME_BY_SAINT_GOBAIN.4e76af4b.pdf";